/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

/* eslint-disable */
const HTMLEllipsis = require("@eisinc/Libraries/react-lines-ellipsis/html.js");
/* eslint-enable */

interface Props extends WidgetProps, HasCategoryContext {}

export interface CategoryDetailBannerStyles {
    container?: InjectableCss;
}

export const bannerStyles: CategoryDetailBannerStyles = {
    container: {
        css: css`
            margin-bottom: 20px;

            & p {
                font-size: 16px;
                line-height: 22px;
                color: ${getColor("text.main")};
            }

            .LinesEllipsis-ellipsis,
            a {
                color: ${getColor("primary.main")} !important;
                cursor: pointer;

                &:hover,
                &:focus {
                    &,
                    span {
                        text-decoration: underline;
                    }
                }
            }
        `,
    },
};

const styles = bannerStyles;

const CategoryDetailBanner = ({ category }: Props) => {
    const [useEllipsis, setUseEllipsis] = React.useState(true);

    const handleTextClick = (e: any) => {
        const target = e.target;

        if (target.id === "CategoryDetailBanner_readMore") {
            e.preventDefault();
            setUseEllipsis(false);
        }
    };

    if (!category || !category.htmlContent) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} onClick={handleTextClick} data-test-selector="categoryDetailBanner_htmlContent">
            {useEllipsis && (
                <HTMLEllipsis
                    unsafeHTML={category.htmlContent}
                    maxLine="3"
                    ellipsisHTML="...<span id='CategoryDetailBanner_readMore'>read more</span>"
                    basedOn="letters"
                />
            )}
            {!useEllipsis && parse(category.htmlContent, parserOptions)}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailBanner),
    definition: {
        group: "Category Details",
        icon: "image-landscape",
        allowedContexts: ["CategoryDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
